import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useMachine } from '@xstate/react';
import { createAIExperienceMachine } from './get-ai-experience-service';
export function useAIExperienceService(options) {
  var machineRef = React.useRef(null);
  if (machineRef.current === null) {
    machineRef.current = createAIExperienceMachine(options);
  }
  var _useMachine = useMachine(machineRef.current),
    _useMachine2 = _slicedToArray(_useMachine, 2),
    state = _useMachine2[0],
    send = _useMachine2[1];
  return {
    // In a later version of xstate -- the type gen means the machine
    // has good types, so these assertions are not required
    state: state.value,
    context: state.context,
    // Out of the box -- the type of the event received by the xstate send
    // will allow any "payload".
    // ie. `send("correct event type", {incorrect: "event payload"})`
    //
    // To avoid related issues -- we've limited the type to only allow
    // sending the full event.
    // ie. `send({type: "correct event type", correct: "event payload"})`
    send: send
  };
}